import React from 'react';
import { styled } from '@compiled/react';

import { token } from '@atlaskit/tokens';

import { WhiteboardUpsell } from '@confluence/change-edition/entry-points/WhiteboardsUpsell';

import type { WhiteboardEditionUpgradeService } from './services/whiteboard-edition-upgrade-service';
import { useEditionUpgradeCTA } from './useEditionUpgradeCTA';

export type WhiteboardEditionUpgradeCTAProps = {
	editionUpgradeService: WhiteboardEditionUpgradeService;
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const CTAContainer = styled.div({
	position: 'absolute',
	width: '440px',
	top: token('space.800'),
	// Just enough margin to align with the rest of our modals on the top right
	right: token('space.150'),
});

export const WhiteboardEditionUpgradeCTA = ({
	editionUpgradeService,
}: WhiteboardEditionUpgradeCTAProps) => {
	const modalState = useEditionUpgradeCTA(editionUpgradeService);

	if (!modalState.isModalOpen) {
		return null;
	}

	return (
		<CTAContainer>
			<WhiteboardUpsell {...modalState.modalProps} onDismissRequest={modalState.closeModal} />
		</CTAContainer>
	);
};
